import React, { useCallback, useRef, useState } from 'react';
import ConfirmDialog from '../components/ConfirmDialog';

// Replacement for window.confirm: `const [confirm, confirmDialog] = useConfirm();`, render
// {confirmDialog} once in the component, then `if (!(await confirm({ title, message }))) return;`.
// Options: title, message, confirmText, cancelText, variant ('danger' | 'primary').
export default function useConfirm() {
  const [state, setState] = useState(null);
  const resolver = useRef(null);

  const settle = useCallback((answer) => {
    // ConfirmDialog calls onConfirm and then onClose: the first answer wins
    if (resolver.current) {
      resolver.current(answer);
      resolver.current = null;
    }
    setState(null);
  }, []);

  const confirm = useCallback((options) => new Promise((resolve) => {
    if (resolver.current) resolver.current(false);
    resolver.current = resolve;
    setState(options);
  }), []);

  const dialog = (
    <ConfirmDialog
      isOpen={!!state}
      onClose={() => settle(false)}
      onConfirm={() => settle(true)}
      title={state?.title}
      message={state?.message}
      confirmText={state?.confirmText}
      cancelText={state?.cancelText}
      variant={state?.variant || 'danger'}
    />
  );

  return [confirm, dialog];
}
